import { useEffect, useState } from 'preact/hooks';
import { logger } from './utils/logger';

export const useProductVariant = () => {
  const [variant, setVariant] = useState<string | null>(null);

  useEffect(() => {
    const interval = setInterval(() => {
      const shopifyVariant = window.ShopifyAnalytics?.meta?.selectedVariantId?.toString();

      if (shopifyVariant && shopifyVariant !== variant) {
        logger.log('Applying variant', shopifyVariant);
        setVariant(shopifyVariant);
      }
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }, [variant]);

  return variant;
};
